export { ArrowUpIcon } from "./arrow-up";
